import { render } from "./SimpleLayout.vue?vue&type=template&id=b267abe6"
const script = {}

import "./SimpleLayout.vue?vue&type=style&index=0&id=b267abe6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__